const ipAddressExp = /^(?:\d{1,3}\.){3}\d{1,3}(?::\d+)?$/;

const INVESTRAN_PROD_BASE_URL =
  "https://investran-us-live.fisglobal.com/InvestranWebApplication-7.5.0/";
const INVESTRAN_UAT_BASE_URL =
  "https://investran-uat-us-live.fisglobal.com/InvestranWebApplication-7.5.0/";

function isProductionEnvironment(): boolean {
  const { hostname } = window.location;
  return hostname === "admin.junipersquare.com";
}

export function getInvestranBaseUrl(): string {
  return isProductionEnvironment() ? INVESTRAN_PROD_BASE_URL : INVESTRAN_UAT_BASE_URL;
}

export function generateGpMainUrl(arenaSecondLevelDomain: string): string {
  const { protocol, host } = window.location;

  if (host.startsWith("localhost") || ipAddressExp.test(host)) {
    return `http://${arenaSecondLevelDomain}.dev.junipersquare.com`;
  }

  const hostnameParts = host.split(".");
  const hostnameWithoutFirstSubdomain = hostnameParts.slice(1);

  return `${protocol}//${arenaSecondLevelDomain}.${hostnameWithoutFirstSubdomain.join(".")}`;
}
